import { AlertTriangle, RotateCcw } from 'lucide-react'
import Modal from './ui/Modal'

interface RegenerationConfirmProps {
  open: boolean
  ideasCount: number
  hasArtifacts: boolean
  hasManualEventStormEdits: boolean
  onCancel: () => void
  onConfirm: () => void
}

export default function RegenerationConfirm({
  open,
  ideasCount,
  hasArtifacts,
  hasManualEventStormEdits,
  onCancel,
  onConfirm,
}: RegenerationConfirmProps) {
  return (
    <Modal
      open={open}
      onClose={onCancel}
      title={hasArtifacts ? 'Regenerar artefatos' : 'Gerar artefatos'}
      size="md"
      footer={
        <div className="flex items-center justify-end gap-2">
          <button
            onClick={onCancel}
            className="px-3 py-1.5 rounded-md text-xs font-medium text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-gray-400"
          >
            Cancelar
          </button>
          <button
            onClick={onConfirm}
            data-autofocus
            className="flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-semibold text-white bg-violet-600 hover:bg-violet-500 shadow-sm focus:outline-none focus:ring-2 focus:ring-agent"
          >
            <RotateCcw size={12} aria-hidden="true" />
            {hasArtifacts ? 'Regenerar agora' : 'Gerar agora'}
          </button>
        </div>
      }
    >
      <div className="space-y-3 text-sm text-gray-600 dark:text-gray-300">
        <p>
          O time de agentes vai reanalisar todas as <strong>{ideasCount}</strong> ideia
          {ideasCount === 1 ? '' : 's'} da sala e gerar uma nova versão completa dos artefatos
          (SDD com ADRs, diagramas Mermaid, Event Storm e Protótipo).
        </p>

        {hasArtifacts && (
          <div className="flex items-start gap-2 rounded-lg bg-amber-50 dark:bg-amber-900/30 border border-amber-200 dark:border-amber-700/60 px-3 py-2 text-xs text-amber-800 dark:text-amber-200">
            <AlertTriangle size={14} className="shrink-0 mt-0.5" aria-hidden="true" />
            <div>
              A versão atual será <strong>substituída</strong>. Ela permanece visível durante a
              regeneração e só é trocada quando a nova versão fica pronta.
              {hasManualEventStormEdits && (
                <p className="mt-1">
                  Notas adicionais que você escreveu no Event Storm <strong>serão preservadas</strong>{' '}
                  apenas se o agente não retornar elementos novos.
                </p>
              )}
            </div>
          </div>
        )}

        <p className="text-xs text-gray-500 dark:text-gray-400">
          A operação costuma levar de <strong>1 a 3 minutos</strong> — você pode continuar
          trabalhando na sala enquanto isso; a barra no topo mostra o progresso.
        </p>
      </div>
    </Modal>
  )
}
